import Panel from "shared/panel";

import Backdraft from "backdraft-app/src/backdraft";

Backdraft.plugin("Panel", plugin => {
  plugin.initializer(app => {
    app.installPlugin("Base");

    app.view.panel = function(name, baseClassName, properties) {
      let baseClass = Panel;
      if (arguments.length === 2) {
        properties = baseClassName;
      } else {
        baseClass = app.Views[baseClassName];
      }

      app.Views[name] = baseClass.extend(properties);
    };
  });

  plugin.exports({
    Panel
  });
});
